import { isCI } from '../utils';
export function artifactId(override) {
    var _a, _b;
    const artifactIdToUse = (_b = (_a = process.env.ARTIFACT_ID) !== null && _a !== void 0 ? _a : process.env.APP_NAME) !== null && _b !== void 0 ? _b : '';
    return {
        'X-Wix-Client-Artifact-Id': override !== null && override !== void 0 ? override : (!isCI() ? artifactIdToUse : ''),
    };
}
//# sourceMappingURL=artifact-id.js.map